module.exports = __webpack_public_path__ + "static/media/team-hyundo.9837a465.jpg";